import React, { useState } from 'react';
import parse from 'html-react-parser';
import Link from '../utils/link';
import { Logo } from './icons';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

const Home = ({ gallery, menu }) => {
  const [image, setImage] = useState(0)

  const half = Math.ceil(menu?.length / 2);
  const firstHalf = menu.slice(0, half)
  const secondHalf = menu.slice(half)

  return (
    <section className='landing landing__overlay'>
      <GatsbyImage image={getImage(gallery[image].localFile)} alt={gallery[image].altText} />
      <div className="landing__main">
        <div className="header__menu header__left">
          <ul>
            {firstHalf.map(({ link, text, description }, index) => (
              <li key={index}>
                <Link to={link} onMouseOver={() => setImage(index)}>{text}</Link>
                {description && (
                  <div className="content">
                    <p>{description}</p>
                  </div>
                )}
              </li>
            ))}
          </ul>
        </div>

        <div className="header__logo-nav">
          <Link to="/home/" title="Kervale" className="header__logo">
            <Logo color={`#FFFFFF`} />
          </Link>
          <nav className="header__nav">
          </nav>
        </div>

        <div className="header__menu header__right">
          <ul>
            {secondHalf.map(({ link, text, description }, index) => (
              <li key={index}>
                <Link to={link} onMouseOver={() => setImage(index + 2)}>{text}</Link>
                {description && (
                  <div className="content">
                    <p>{description}</p>
                  </div>
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

Home.defaultProps = {
  gallery: [],
  menu: [],
};

export default Home